module.exports = __webpack_public_path__ + "img/img3.9a82fa34.png";